import React, { useEffect } from 'react';
import { useRive, Layout, Fit, Alignment } from '@rive-app/react-canvas';

interface CatGuardianProps {
    isWorking: boolean; // 현재 진행 중인 업무가 있는지 여부
}

const CatGuardian = ({ isWorking }: CatGuardianProps) => {
    const animationName = 'Sulamine'; // 녹는 애니메이션 이름

    const { rive, RiveComponent } = useRive({
        src: '/riv/icecream-cat.riv',
        artboard: 'Kass',
        animations: animationName,
        autoplay: false, // 처음엔 멈춰있음
        layout: new Layout({
            fit: Fit.Contain,
            alignment: Alignment.Center,
        }),
    });

    useEffect(() => {
        if (rive) {
            if (isWorking) {
                // 업무 중이면 녹는 애니메이션 재생
                rive.play(animationName);
            } else {
                // 업무가 없으면 재생 중단 (그 자리에 멈춤)
                rive.stop(animationName);
            }
        }
    }, [isWorking, rive]);

    return (
        <div style={{ width: '100%', height: '500px' }}>
            <RiveComponent />
        </div>
    );
};

export default CatGuardian;